import React from 'react'
import { useDispatch} from 'react-redux';
import { clearCart } from '../Actions/Cart.action';

export default function MyPagesObserver() {

    const dispatch = useDispatch();
        if(localStorage.getItem("fromMyPages") && localStorage.getItem("fromMyPages") != window.location.pathname){
            if(window.location.hash !== "#policy"){
                dispatch(clearCart()) 
                .then( ()=>{
                    localStorage.clear("fromMyPages"); 
                })
            }
        }
    return (
        <></>
    )
  }